import { localStorage } from "../../utils/globalUtils";
import { safeJSONParse } from "../../utils";
import { TInterest } from "../../pages/UserOnboarding/Interests/types";
import { KEY_MAP } from "./constants";

class LocalStorage {
  public getQuestInvitationPageState(): {
    issueId?: string;
    openModal?: string;
  } {
    const questInvitationPageState =
      localStorage?.getItem(KEY_MAP.QUEST_INVITATION_PAGE_STATE) || "";

    return safeJSONParse(questInvitationPageState) || {};
  }

  public setQuestInvitationPageState(props: {
    issueId: string;
    openModal?: boolean;
  }) {
    localStorage?.setItem(
      KEY_MAP.QUEST_INVITATION_PAGE_STATE,
      JSON.stringify(props)
    );
  }

  public deleteQuestInvitationPageState() {
    localStorage?.removeItem(KEY_MAP.QUEST_INVITATION_PAGE_STATE);
  }

  public getIsOrgAdminSignUp() {
    const isOrgAdminSignUp = localStorage?.getItem(
      KEY_MAP.IS_ORG_ADMIN_SIGN_UP
    );

    return isOrgAdminSignUp === "true";
  }

  public setIsOrgAdminSignUp(value: boolean) {
    localStorage?.setItem(KEY_MAP.IS_ORG_ADMIN_SIGN_UP, value.toString());
  }

  public deleteIsOrgAdminSignUp() {
    localStorage?.removeItem(KEY_MAP.IS_ORG_ADMIN_SIGN_UP);
  }

  public getOrgQuestsPathAndIssueUrl(): {
    orgPath?: string;
    issueUrl?: string;
  } {
    const orgQuestsPathAndIssueUrl =
      localStorage?.getItem(KEY_MAP.ORG_QUESTS_PATH_AND_ISSUE_URL) || "";
    return safeJSONParse(orgQuestsPathAndIssueUrl) || {};
  }

  public setOrgQuestsPathAndIssueUrl(data: {
    orgPath: string;
    issueUrl: string;
  }) {
    localStorage?.setItem(
      KEY_MAP.ORG_QUESTS_PATH_AND_ISSUE_URL,
      JSON.stringify(data)
    );
  }

  public deleteOrgQuestsPathAndIssueUrl() {
    localStorage?.removeItem(KEY_MAP.ORG_QUESTS_PATH_AND_ISSUE_URL);
  }

  public getWhitelistStatus() {
    return localStorage?.getItem(KEY_MAP.SHOULD_WHITELIST_USER);
  }

  public setWhitelistStatus(status: boolean) {
    localStorage?.setItem(KEY_MAP.SHOULD_WHITELIST_USER, `${status}`);
  }

  public deleteWhitelistStatus() {
    localStorage?.removeItem(KEY_MAP.SHOULD_WHITELIST_USER);
  }

  public getAccessToken() {
    return localStorage?.getItem(KEY_MAP.ACCESS_TOKEN);
  }

  public getExpiresAt() {
    return localStorage?.getItem(KEY_MAP.EXPIRES_AT);
  }

  public getUserId(): number | null {
    const savedUserId = localStorage?.getItem(KEY_MAP.USER_ID);
    return savedUserId ? Number.parseInt(savedUserId) : null;
  }

  public getStripeCheckoutData(): object {
    const stripeCheckoutDataJSONString =
      localStorage?.getItem(KEY_MAP.STRIPE_CHECKOUT_DATA) || "";
    return safeJSONParse(stripeCheckoutDataJSONString) || {};
  }

  public getHasSeenContributorQuestsIntro(): boolean {
    return (
      localStorage?.getItem(KEY_MAP.HAS_SEEN_CONTRIBUTOR_QUESTS_INTRO) ===
      "true"
    );
  }

  public setHasSeenContributorQuestsIntro(seen: boolean) {
    localStorage?.setItem(KEY_MAP.HAS_SEEN_CONTRIBUTOR_QUESTS_INTRO, `${seen}`);
  }

  public setAuth(accessToken: string, expiresAt: string) {
    localStorage?.setItem(KEY_MAP.ACCESS_TOKEN, accessToken);
    localStorage?.setItem(KEY_MAP.EXPIRES_AT, expiresAt);
  }

  public setUserId(userId: number) {
    localStorage?.setItem(KEY_MAP.USER_ID, `${userId}`);
  }

  public setStripeCheckoutData(data: object) {
    localStorage?.setItem(KEY_MAP.STRIPE_CHECKOUT_DATA, JSON.stringify(data));
  }

  public deleteAuth() {
    localStorage?.removeItem(KEY_MAP.ACCESS_TOKEN);
    localStorage?.removeItem(KEY_MAP.EXPIRES_AT);
    localStorage?.removeItem(KEY_MAP.USER_ID);
    this.deleteDiscordAuthRedirectUrl();
    this.deleteStripeCheckoutData();
  }

  public deleteStripeCheckoutData() {
    localStorage?.removeItem(KEY_MAP.STRIPE_CHECKOUT_DATA);
  }

  public setDiscordAuthRedirectUrl(path: string) {
    localStorage?.setItem(KEY_MAP.DISCORD_AUTH_REDIRECT_URL, path);
  }

  public getDiscordAuthRedirectUrl() {
    return localStorage?.getItem(KEY_MAP.DISCORD_AUTH_REDIRECT_URL);
  }

  public deleteDiscordAuthRedirectUrl() {
    localStorage?.removeItem(KEY_MAP.DISCORD_AUTH_REDIRECT_URL);
  }

  public getOnboardingInterests(): TInterest[] {
    const interests = safeJSONParse(
      localStorage?.getItem(KEY_MAP.ONBOARDING_INTERESTS) || ""
    ) as TInterest[];
    return interests ? interests : [];
  }

  public setOnboardingInterests(interests: TInterest[]) {
    localStorage?.setItem(
      KEY_MAP.ONBOARDING_INTERESTS,
      JSON.stringify(interests)
    );
  }
  public getEmailVerificationSent(): boolean {
    const value = localStorage?.getItem(KEY_MAP.EMAIL_VERIFICATION_SENT);
    return value === "true";
  }
  public setEmailVerificationSent(value = true) {
    localStorage?.setItem(KEY_MAP.EMAIL_VERIFICATION_SENT, String(value));
  }
  public removeEmailVerificationSent() {
    localStorage?.removeItem(KEY_MAP.EMAIL_VERIFICATION_SENT);
  }
}

const localStorageInstance = new LocalStorage();

export default localStorageInstance;
